import {
  Animation,
  Flex,
  Title,
  Button,
  SelectedItemsContainer,
  TabFooter,
} from 'styling/GlobalStyles'
import { ITaskTemplatesTab } from 'types/task-templates.interface'
import { CancelBtn } from 'components/Button/CancelBtn'
import { ItemsPick } from 'components/ItemsPick/ItemsPick'
import { SelectedItem } from 'components/ItemsPick/SelectedItem'
import { INameId } from 'constants/globalTypes'

export const TaskTFallBackRolesTab = ({ state, setState, handleSubmit }: ITaskTemplatesTab) => {

  const handleAdd = (item: INameId) => {

    if (state.fallBackRoles.find(role => role.id === item.id)) {
      setState(prev => ({ ...prev, fallBackRoles: prev.fallBackRoles.filter(role => role.id !== item.id) }))
    } else {
      setState(prev => ({ ...prev, fallBackRoles: [...prev.fallBackRoles, item] }))
    }

  }

  return (
    <>
      <Animation>
        <Flex between minHeight='600px' gap='2rem'>
          <SelectedItemsContainer>
            <Title pad='0 20px'>Selected Roles</Title>
            {state.fallBackRoles.map((item) => {
              return (
                <SelectedItem setState={setState} key={item.id} data={item} type='fallBackRoles' />
              )
            })}
          </SelectedItemsContainer>
          <ItemsPick
            placeholder='Search roles'
            selectedList={state.fallBackRoles}
            handleAdd={handleAdd}
            link='roles'
          />
        </Flex>

        <TabFooter>
          <Flex gap='1rem'>
            <CancelBtn />
            <Button orange onClick={handleSubmit}>
              Save
            </Button>
          </Flex>
        </TabFooter>
      </Animation>

    </>
  )
}
